import { TableFilter } from "@/types/utils";

type NumberKeys = "last_login";

export type StringKeys =
  | "vid"
  | "bid"
  | "orders_table_view"
  | "brand_orders_table_view";

export type ObjectKeys =
  | "orders_filter"
  | "brand_orders_filter"
  | "dashboard_filter"
  | "products_filter";

type Keys = StringKeys | NumberKeys | ObjectKeys;

function getItem(key: NumberKeys): number | undefined;
function getItem(key: StringKeys): string | undefined;
function getItem(key: ObjectKeys): TableFilter | undefined;

function getItem<D>(key: Keys): D | undefined {
  const value = localStorage.getItem(key);

  if (!value) return undefined;
  return JSON.parse(value);
}

function setItem(key: NumberKeys, value: number): void;
function setItem(key: StringKeys, value: string): void;
function setItem(key: ObjectKeys, value: TableFilter): void;

function setItem<D>(key: Keys, value: D) {
  localStorage.setItem(key, JSON.stringify(value));
}

function removeItem(key: Keys) {
  localStorage.removeItem(key);
}

function clear() {
  localStorage.clear();
}

export default {
  getItem,
  setItem,
  removeItem,
  clear,
};
